import { cn } from '@fe-learner-common';
import { FC, LiHTMLAttributes } from 'react';
interface ListItemProps extends LiHTMLAttributes<HTMLLIElement> {
  disabled?: boolean;
}

export const ListItem: FC<ListItemProps> = ({
  children,
  disabled,
  className,
}) => {
  return (
    <li
      role="article"
      className={cn(
        'group relative isolate mb-2 flex cursor-pointer items-start justify-between gap-x-2 rounded-lg bg-white transition-colors hover:bg-neutral-100',
        'after:content after:absolute after:-bottom-2 after:left-4 after:right-4 after:border-b-1 after:border-neutral-100',
        {
          'cursor-not-allowed': disabled,
        },
        className,
      )}
    >
      {children}
    </li>
  );
};
